<div class="business-data-form" [formGroup]="businessData.formGroup">
  <app-image-upload [fileUploadLabel]="businessData.labels.fileUpload"
                    id="data-image-upload"
                    [fileUploadAlt]="businessData.labels.fileUploadAlt"
                    [abstractControl]="businessData.formGroup.get('picture')">
  </app-image-upload>
  <form>
    <app-input id="business-name-input"
               [control]="getControl('businessName')"
               [label]="businessData.labels.businessName"
        required>
    </app-input>
    <app-input id="business-address-input"
               [control]="getControl('businessAddress')"
               [label]="businessData.labels.businessAddress">
    </app-input>
    <app-input id="business-number-input"
               [control]="getControl('number')"
               [label]="businessData.labels.number">
    </app-input>
    <app-select id="business-country-input"
                [control]="getControl('country')"
                [label]="businessData.labels.country"
                [options]="businessData.options.country"
                required
                [hasIdAndValue]="true"
                (selectionChange)="getProvinces(true)"
                [disabled]="true">
    </app-select>
    <app-select id="business-state-input"
                [control]="getControl('state')"
                [label]="businessData.labels.state"
                [options]="getProvinces()"
                required
                [hasIdAndValue]="true"
                [isValueString]="true">
    </app-select>
    <app-input id="business-postal-code-input"
               [control]="getControl('postalCode')"
               [label]="businessData.labels.postalCode">
    </app-input>
    <app-input id="business-phone"
               required
               [control]="getControl('phoneNumber')"
               [label]="businessData.labels.phone"
               isPhoneNumber
               [mask]="mask">
    </app-input>
    <app-input id="business-email-input"
               [control]="getControl('businessContactEmail')"
               type="email"
               [label]="businessData.labels.businessContactEmail"
               [type]="businessContactEmailInputType"
               required>
    </app-input>
    <app-select id="business-type-input"
                [control]="getControl('typeOfBusiness')"
                [label]="businessData.labels.typeOfBusiness"
                [options]="businessData.options.businessType"
                [hasIdAndValue]="true">
    </app-select>
    <app-input id="business-website-input"
               [control]="getControl('businessWebsite')"
               type="url"
               [label]="businessData.labels.businessWebsite">
    </app-input>
  </form>
</div>
